import { render, staticRenderFns } from "./corrigir-cobranca.vue?vue&type=template&id=4c29e0ac&scoped=true"
import script from "./corrigir-cobranca.vue?vue&type=script&lang=js"
export * from "./corrigir-cobranca.vue?vue&type=script&lang=js"
import style0 from "./corrigir-cobranca.vue?vue&type=style&index=0&id=4c29e0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c29e0ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VDataTable,
  VFlex,
  VLayout,
  VTextField,
})
